import { format } from 'date-fns';
import { useAtomValue, useSetAtom } from 'jotai';
import { useShowHints } from '@/api/mutations/useAuthMutations';
import { useUserQuery } from '@/api/queries/useAuth';
import { hintsAtom } from '@/atoms/hints';
import { HINTS } from '@/constants';
import type { hintsBlock } from '@/enums';
import { useProjectId } from '@/hooks';

export const useHints = () => {
    const { data: user } = useUserQuery();
    const { mutate: showHints } = useShowHints();
    const setHint = useSetAtom(hintsAtom);
    const hintBlockState = useAtomValue(hintsAtom).block;
    const projectId = useProjectId();

    const displayHints = (type: hintsBlock) => {
        if (hintBlockState || !projectId) return;

        if (user) {
            const { hint_show_count } = user;
            const hintBlock = hint_show_count.find(h => h.type === type);

            const displayHint = () => {
                showHints({ type });
                setHint({ block: type, item: Object.values(HINTS[type])[0]?.name ?? null });
            };

            if (!hintBlock) {
                displayHint();
                return;
            }

            if (hintBlock) {
                const time = new Date();
                const dayUPD = Number(format(new Date(hintBlock.updated_at), 'd'));
                if (time.getDate() !== dayUPD && hintBlock.count < 5) {
                    displayHint();
                }
            }
        }
    };

    return {
        displayHints,
    };
};
